import { render, staticRenderFns } from "./TempConfigBaseSettingsList.vue?vue&type=template&id=327780ba&scoped=true"
import script from "./TempConfigBaseSettingsList.vue?vue&type=script&lang=js"
export * from "./TempConfigBaseSettingsList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigBaseSettingsList.vue?vue&type=style&index=0&id=327780ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327780ba",
  null
  
)

export default component.exports